import React from 'react';

class RowItemCongTacQuanLyThanhTra extends React.Component {

  render() {
    let Item = this.props.item;
    let data = Item ? Item.soLieuBaoCaoInfo : {};
    return (
      <tr className={this.props.sum ? 'txt-bold' : ''}>
        <td className='column-stt-fixed'>{this.props.count}</td>
        <td className='column-name-fixed'>{data.tenDonVi}</td>

        <td className='txt-center'>{data.soVanBanBanHanhMoi}</td>
        <td className='txt-center'>{data.soVanBanDuaSuaDoiBoSung}</td>
        <td className='txt-center'>{data.phapLuatVeTTLop}</td>
        <td className='txt-center'>{data.phapLuatVeTTNguoi}</td>
        <td className='txt-center'>{data.phapLuatVeTT_KNTC_PCTN_Lop}</td>
        <td className='txt-center'>{data.phapLuatVeTT_KNTC_PCTN_Nguoi}</td>
        <td className='txt-center'>{data.thucHienPLVeThanhTraSoCuoc}</td>
        <td className='txt-center'>{data.thucHienPLVeThanhTraSoDonVi}</td>
        <td className='txt-center'>{data.thucHienPLVeThanhTraKNTCPCTNSoCuoc}</td>
        <td className='txt-center'>{data.thucHienPLVeThanhTraKNTCPCTNSoDonVi}</td>
        <td className='txt-center'>{data.soDonViCoViPham}</td>
        <td className='txt-center'>{data.kienNghiXuLyKiemDiemRutKNToChuc}</td>
        <td className='txt-center'>{data.kienNghiXuLyKiemDiemRutKNCaNhan}</td>
        <td className='txt-center'>{data.kienNghiXuLyHanhChinhToChuc}</td>
        <td className='txt-center'>{data.kienNghiXuLyHanhChinhCaNhan}</td>
        <td className='txt-center'>{data.tongSoKLTTVaQDXLDaKiemDiem}</td>
        <td className='txt-center'>{data.ketQuaKTDaKiemDiemRutKNToChuc}</td>
        <td className='txt-center'>{data.ketQuaKTDaKiemDiemRutKNCaNhan}</td>
        <td className='txt-center'>{data.daXLHanhChinhToChuc}</td>
        <td className='txt-center'>{data.daXLHanhChinhCaNhan}</td>
        <td className='ghi-chu'>{data.ghiChu}</td>
      </tr>
    );
  }
}

export default RowItemCongTacQuanLyThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/bao-cao-tong-hop/datatable/RowItemCongTacQuanLyThanhTra.jsx